import React from 'react';
import PropTypes from 'prop-types';
import styles from './SensorDataWidget.module.css';

const rowKey = (row, idx) => (
  row.channelId != null
    ? row.channelId
    : `${row.sensorName}-${row.component}-${idx}`
);

const SensorDataTable = ({ rows, colorByChannelId }) => {
  if (!rows || rows.length === 0) {
    return (
      <div className="p-3 text-center text-muted">
        No sensor readings to display.
      </div>
    );
  }

  return (
    <table className="table table-sm table-striped mb-0">
      <thead>
        <tr>
          <th>Sensor Name</th>
          <th>Component</th>
          <th>Sensor Channel</th>
          <th>Last Reading</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => {
          const dotColor = row.color || colorByChannelId[row.channelId] || null;
          return (
            <tr key={rowKey(row, idx)}>
              <td>
                {dotColor && (
                <span
                  aria-hidden="true"
                  className={styles.colorDot}
                  style={{ backgroundColor: dotColor }}
                />
                )}
                {row.sensorName}
              </td>
              <td>{row.component}</td>
              <td>{row.sensorChannel}</td>
              <td>{row.lastReading}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

SensorDataTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    channelId: PropTypes.number,
    sensorName: PropTypes.string,
    component: PropTypes.string,
    sensorChannel: PropTypes.string,
    lastReading: PropTypes.string,
    color: PropTypes.string,
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  colorByChannelId: PropTypes.object,
};

SensorDataTable.defaultProps = {
  colorByChannelId: {},
};

export default SensorDataTable;
